<p-dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '90rem', maxWidth: '96vw', height: '90vh' }"
  [contentStyle]="{
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '0',
    overflow: 'hidden',
  }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  header="Pull Direction"
>
  @if (loading) {
    <div class="flex items-center justify-center gap-2 py-12">
      <i class="pi pi-spin pi-spinner text-primary"></i>
      <span class="text-sm text-muted-color">Loading CAD geometry...</span>
    </div>
  } @else {
    <p class="mb-4 mt-0 text-sm leading-6 text-muted-color">
      The pull direction is the direction in which the part is pulled off the
      mould. Suitable pull directions are detected automatically and listed as
      suggestions. Pick one of the suggestions, or set your own by entering a
      vector, using the camera direction, or clicking a face on the model. The
      selected direction is used by later steps to compute the moulding surface.
    </p>
    <app-pull-directions
      class="block min-h-0 flex-1"
      [cadObjects]="cadObjects"
      [primaryCadObjectId]="primaryCadObjectId"
      [pullDirections]="pullDirections"
      [selectedPullDirection]="selectedPullDirection"
      [showHeader]="false"
      [showFindPullDirection]="true"
      [findPullDirectionLoading]="findingPullDirection"
      [findPullDirectionDisabled]="!canFindPullDirection"
      [findPullDirectionTooltip]="
        processing.downstreamExecutionActive()
          ? 'Downstream steps are running. Wait for the sequence to finish.'
          : null
      "
      (pullDirectionSelected)="onPullDirectionSelected($event)"
      [cadFileId]="cadFileId"
      (findPullDirection)="onFindPullDirection()"
    />
  }

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      @if (actionError || (status === "error" && runErrorMessage)) {
        <span class="self-center text-sm text-red-600">{{
          actionError ?? runErrorMessage
        }}</span>
      }
      <p-button
        label="Close"
        severity="secondary"
        [outlined]="true"
        (onClick)="onClose()"
      />
      <span
        [pTooltip]="
          processing.downstreamExecutionActive()
            ? 'Downstream steps are running. Wait for the sequence to finish.'
            : undefined
        "
        tooltipPosition="top"
      >
        <p-button
          label="Save"
          [loading]="savingCustomDirection"
          [disabled]="
            savingCustomDirection ||
            findingPullDirection ||
            processing.downstreamExecutionActive()
          "
          (onClick)="onSave()"
        />
      </span>
    </div>
  </ng-template>
</p-dialog>
